import {
  Button,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import AddDynamicFields from "../components/common/controls/AddDynamicFields";
import AntSwitch from "../components/common/controls/AntSwitch";
import CustomButton from "../components/common/controls/CustomButton";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import DMModal from "../components/common/controls/DMModal";
import DMSelect from "../components/common/controls/DMSelect";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import { sortMoelService } from "../services/ModelsService";
import { uuidv4 } from "../utilities/applicationutils";
import "./pageStyles.scss";
import Loading from "../components/Loading/Loading";
import { width } from "@fortawesome/free-solid-svg-icons/faSave";
import ModelVersion from "../components/common/controls/ModelVersion";
import ModelStatusChip from "../components/common/controls/ModelStatusChip";
import WarningPopup from "../components/common/controls/warningPopup";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../constants/constants";

var CONTROLS_DATA = require("./ControlsData.json");
var MODELS_CONTROLS = CONTROLS_DATA.SCREENS.MODELS;

const Models = ({
  modelState,
  getModels,
  deleteModel,
  createNewModel,
  updateModel,
  getRegions,
  onMoreOptionsSelected,
  onTabSelected,
  setSnackBar,
  onPageSelected,
  onCloseSelected,
  intl,
  fullLangCode,
}) => {
  const [models, setModels] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [showNewModel, setShowNewModel] = useState(false);
  const [newModel, setNewModel] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showMoreOptionsdisabled, setShowMoreOptionsDisabled] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedModel, setSelectedModel] = useState();

  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  const [isUnsaveChanges, setIsUnsaveChanges] = useState(false);
  const [regionUpate, setRegionUpate] = useState(false);

  const onNewProjectClick = () => setShowNewModel(true);

  useEffect(() => {
    onPageSelected(1);
  }, []);

  const onSelectedPage = (selectedPage) => {
    onPageSelected(selectedPage);
  };

  const handleChange = (value) => {
    setSortBy(value);
  };

  const handleNewModelName = (e) => {
    setNewModel({ ...newModel, model: e.target.value });
  };

  const handleRegionNewModel = (e) => {
    setNewModel({ ...newModel, region: e.target.value });
  };

  const handleStatusNewModel = (e) => {
    setNewModel({ ...newModel, status: e.target.checked });
  };

  const onEdit = (modelId) => {
    onCloseSelected({
      id: uuidv4(),
      isClosed: false,
    });
    setShowEdit(true);
    setSelectedModel(models.filter((m) => m.modelId === modelId)[0]);
  };

  const onDelete = (modelId) => {
    setShowDelete(true);
    setSelectedModel(models.filter((m) => m.modelId === modelId)[0]);
  };

  const onMoreOptions = (event, modelId, status = "") => {
    setShowMoreOptions(true);
    setShowMoreOptionsDisabled(status === "Published" ? true : false);
    setAnchorEl(event.currentTarget);
    setSelectedModel(modelId);
  };

  const getRegionName = (model) => {
    const arr = [...modelState?.regions?.data];
    const region = arr.find((ele) => ele?.regionId === model?.regionId);
    return region?.regionName;
  };

  const repTextValue = (model) => {
    const newm = model?.replaceableText;
    const filterData = newm.slice().sort((a, b) => a.sort - b.sort) || [];
    return filterData;
  };

  async function onUpdateModelSwitch(model, value) {
    try {
      const payload = {
        modelId: model.modelId,
        modelName: model.modelName,
        regionId: model.regionId,
        isActive: value,
      };
      await updateModel(payload);
      if (!modelState.updateModel.hasError) {
        await getModels();
        //  setModels(modelState.models.data);
        setSnackBar(
          true,
          "success",
          `${model.modelName} ${injectIntlTranslation(
            intl,
            "modelupdateSuccess",
            constants.modelupdateSuccess
          )}`
        );
      }
    } catch (error) {
      setShowNewModel(false);
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "modelupdateError",
          constants.modelupdateError
        )} ${model?.model}`
      );
    }
  }

  const isModelRegionPresent = (selectedModal, regionId, data) => {
    let isPresent = false;
    for (let model of data) {
      if (
        selectedModal?.modelName.toLowerCase() ==
          model.modelName.toLowerCase() &&
        regionId == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const onUpdateModelRegion = async (model, value) => {
    if (isModelRegionPresent(model, value, modelState.models.data)) {
      setGridData([]);
      setModels([...models]);
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "modelRegionError",
          constants.modelRegionError
        )
      );
    } else {
      setRegionUpate({
        modelName: model.modelName,
        callBack: async () => {
          try {
            const payload = {
              modelId: model.modelId,
              modelName: model.modelName,
              regionId: value,
              isActive: model.status,
            };
            await updateModel(payload);
            if (!modelState.updateModel.hasError) {
              setSnackBar(
                true,
                "success",
                injectIntlTranslation(
                  intl,
                  "modelRegionUpdate",
                  constants.modelRegionUpdate
                )
              );
              await getModels();
              // setModels(modelState.models.data);
              setSnackBar(
                true,
                "success",
                `${model.modelName} ${injectIntlTranslation(
                  intl,
                  "modelupdateSuccess",
                  constants.modelupdateSuccess
                )}`
              );
            }
          } catch (error) {
            setShowNewModel(false);
            setSnackBar(
              true,
              "error",
              `${injectIntlTranslation(
                intl,
                "modelupdateError",
                constants.modelupdateError
              )} ${model?.model}`
            );
          }
        },
      });
    }
  };

  const onUpdateModelName = async (value, model) => {
    const { isSame, isPresent } = isModelPresent(
      value,
      model,
      modelState.models.data
    );
    if (isSame) {
      return;
    }
    if (isPresent) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "modelExistError",
          constants.modelExistError
        )
      );
      setGridData([]);
      setModels([...models]);
    } else {
      try {
        const payload = {
          modelId: model.modelId,
          modelName: value,
          regionId: model.regionId,
          isActive: model.status,
        };
        await updateModel(payload);
        if (!modelState.updateModel.hasError) {
          setSnackBar(
            true,
            "success",
            injectIntlTranslation(
              intl,
              "modelNameUpdate",
              constants.modelNameUpdate
            )
          );
          await getModels();
          // setModels(modelState.models.data);
          setSnackBar(
            true,
            "success",
            `${value} ${injectIntlTranslation(
              intl,
              "modelupdateSuccess",
              constants.modelupdateSuccess
            )}`
          );
        }
      } catch (error) {
        setShowNewModel(false);
        setSnackBar(
          true,
          "error",
          `${injectIntlTranslation(
            intl,
            "modelupdateError",
            constants.modelupdateError
          )} ${model?.model}`
        );
      }
    }
  };

  useEffect(() => {
    const models = [...modelState.models.data];
    if (modelState.regions.data.length > 0) {
      const updatedGrid = models.map((item) => {
        return { ...item, regionName: getRegionName(item) };
      });
      setModels(updatedGrid);
    }
  }, [modelState.regions.data]);

  const updateData = async (update) => {
    await getModels();
  };

  const onSortUpdate = async (sortedData) => {
    if (sortedData.length > 0) {
      const filteredPayload = [];
      sortedData.forEach((item, index) => {
        const isEmpty = item?.id.includes("dep");
        if (!isEmpty) {
          const paylod = {
            id: item.id,
            sort: item.sort,
          };
          filteredPayload.push(paylod);
        }
      });
      if (filteredPayload.length > 0) {
        await sortMoelService(filteredPayload)
          .then((response) => {})
          .catch((error) => {
            setSnackBar(
              true,
              "error",
              injectIntlTranslation(
                intl,
                "sortingError",
                constants.sortingError
              )
            );
          });
      }
    }
  };

  useEffect(() => {
    getModels();
  }, []);

  useEffect(() => {
    if (modelState?.models?.data?.length) {
      getRegions();
    }
  }, [modelState.models.data]);

  useEffect(() => {
    setIsDisabled(
      !(newModel && newModel?.region?.length > 0 && newModel?.model?.length > 0)
    );
  }, [newModel]);

  useEffect(() => {
    if (modelState.models.hasError) {
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "retriveModelError",
          constants.retriveModelError
        )
      );
    }
  }, [modelState.models.hasError]);

  const [backModel, setBackModel] = useState([]);

  useEffect(() => {
    if (backModel.length) {
      setModels(backModel);
    }
  }, backModel);

  const setModelToModified = (item) => {
    let temp = models.map((ele) => {
      if (ele.id === item) {
        ele.status = !ele.status;
      }
      return ele;
    });
    setBackModel([...temp]);
    setModels([]);
  };

  useEffect(() => {
    const ctrlData = [];
    if (searchValue.length > 0) {
      onPageSelected(0);
    }
    let filteredModels = models?.filter(
      (e) =>
        e?.modelName?.toLowerCase()?.includes(searchValue) ||
        e?.regionName?.toLowerCase()?.includes(searchValue)
    );
    const sortedData = _.sortBy(
      filteredModels,
      sortBy !== "status" && sortBy !== ""
        ? (obj) => obj[sortBy]?.toLowerCase()
        : sortBy
    );
    sortedData.forEach((model, i) => {
      const cloneModel = _.cloneDeep(model);
      ctrlData.push({
        rowKey: model.modelId,
        highlight: model.status ? "" : "highlight",
        modelName: model.modelName,
        regionName: getRegionName(model),
        status: model.status,
        rowValue: [
          {
            colType: "contained-label",
            colOptions: {
              width: "256px",
              value: model.modelName,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
              intl: intl,
              fullLangCode: fullLangCode,
              disabled: true,
            },
          },
          {
            colType: "grid-select",
            colOptions: {
              tab: "models",
              model: model,
              searchPlaceHolderText: "Search for a Region",
              selectInfoText: "Select a Region",
              selectedValue: getRegionName(model),
              width: "100px",
              menuList: regions,
              textWidth: "100px",
              popperWidth: "211px",
              popperHeight: "324px",
              onUpdate: onUpdateModelRegion,
              onChange: () => {
                // setShowAlert(true); setAlertSeverity('success'); setAlertMessage(`${model.modelName}-${model.regionName} has been updated.`)
              },
            },
          },
          {
            colType: "ant-switch",
            colOptions: {
              tab: "models",
              value: model.status,
              model: model,
              onUpdate: onUpdateModelSwitch,
              onChange: () => {},
            },
          },
          // {
          //   colType: "custom-component",
          //   component: () => {
          //     return <>V1.0</>;
          //   },
          //   colOptions: {
          //     value: model.status,
          //     model: model,
          //   },
          // },
          // {
          //   colType: "custom-component",
          //   component: () => {
          //     return (
          //       <>
          //         {[2, 3].includes(i) && (
          //           <ModelStatusChip status={"Modified"} model={model} intl={intl} fullLangCode={fullLangCode}/>
          //         )}
          //         {[4, 5, 6].includes(i) && (
          //           <ModelStatusChip status={"Draft"} model={model} intl={intl} fullLangCode={fullLangCode}/>
          //         )}
          //         {![2, 3, 4, 5, 6].includes(i) && (
          //           <ModelStatusChip status={"Published"} model={model} intl={intl} fullLangCode={fullLangCode}/>
          //         )}
          //       </>
          //     );
          //   },
          //   colOptions: {
          //     value: model.status,
          //     model: model,
          //   },
          // },
          {
            colType: "grid-actions",
            selectedModel: model.modelId,
            colOptions: [
              {
                name: "edit",
                tab: "models",
                action: () => onEdit(model.modelId),
                onCloseSidePanel: () => {
                  if (isUnsaveChanges) {
                    setUnsaveChangePopup(true);
                  } else {
                    onCloseSelected({
                      id: "",
                      isClosed: true,
                    });
                  }
                },
                width: "1100px",
                sidePanelContent: (
                  <AddDynamicFields
                    title={`${model.modelName} - ${injectIntlTranslation(
                      intl,
                      "information",
                      constants.information
                    )}`}
                    subTitle={injectIntlTranslation(
                      intl,
                      "blockInformationSubtitle",
                      constants.blockInformationSubtitle
                    )}
                    repText={repTextValue(cloneModel)}
                    modelId={model?.modelId}
                    onshowEdit={handleShowEdit}
                    sortUpdate={onSortUpdate}
                    update={updateData}
                    isUnsaveChanges={isUnsaveChanges}
                    setIsUnsaveChanges={(val) => {
                      setIsUnsaveChanges(val);
                    }}
                    modelData={models}
                  />
                ),
              },
              // {
              //   name: "copy",
              //   action: () => {
              //     // setModelToModified(model.modelId);
              //   },
              // },
              { name: "delete", action: () => onDelete(model.modelId) },
              {
                name: "more-options",
                action: (e) => {
                  const modified = [2, 3];
                  const draft = [4, 5, 6];
                  let status = modified.includes(i)
                    ? "Modified"
                    : draft.includes(i)
                    ? "Draft"
                    : "Published";
                  onMoreOptions(e, model.modelId, status);
                },
              },
            ],
          },
        ],
      });
    });
    setGridData(ctrlData);
  }, [
    models,
    searchValue,
    sortBy,
    isUnsaveChanges,
    selectedModel,
    fullLangCode,
  ]);

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 222,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "45% 30% 15% 10%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Roboto",
      fontWeight: "500",
    },
    saveButton: {
      minWidth: "150px",
      padding: "10px",
      backgroundColor: "#0e3b8d",
      color: "white",
      border: "none",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      marginLeft: "auto",
    },
    cancelbutton: {
      width: "150px",
      padding: "10px",
      backgroundColor: "#fff",
      color: "#000",
      border: "1px solid #000",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      marginLeft: "15px",
    },
  }));

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMoreOptionsClose = (tabId) => {
    setAnchorEl(null);
    let [t = null] = models.filter((x) => x.modelId === selectedModel);

    onMoreOptionsSelected({ id: selectedModel, name: t?.modelName || "" });
    if ([1, 2, 3].includes(tabId)) {
      onTabSelected(tabId);
    } else if (tabId === 4) {
      window[`set${selectedModel}Toggle`](true);
    } else if (tabId === 5) {
      window.showVersionHistory();
    } else if (tabId === 6) {
      onTabSelected(4);
    }
  };

  const handleSearch = _.debounce(function (val) {
    setSearchValue(val?.toLowerCase());
  }, 700);

  const isModelPresent = (modelName, selectedModel, data) => {
    let isPresent = false;

    if (modelName === selectedModel.modelName) {
      return { isSame: true, isPresent };
    }

    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel.regionId == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }

    return { isSame: false, isPresent };
  };

  const isModelPresentInNew = (modelName, selectedModel, data) => {
    let isPresent = false;
    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel?.region == model.regionId
      ) {
        isPresent = true;
        break;
      }
    }
    return isPresent;
  };

  const handleCreateModel = async () => {
    const isPresent = isModelPresentInNew(
      newModel.model,
      newModel,
      modelState.models.data
    );
    setShowNewModel(false);
    setIsDisabled(true);
    setLoading(true);
    setNewModel({ ...newModel, region: "", model: "" });
    if (isPresent) {
      setLoading(false);
      setSnackBar(
        true,
        "error",
        injectIntlTranslation(
          intl,
          "modelExistError",
          constants.modelExistError
        )
      );
    } else {
      try {
        const payload = {
          modelName: newModel.model,
          regionId: newModel?.region,
          isActive: newModel.status,
        };
        await createNewModel(payload);

        if (!modelState.createNewModel.hasError) {
          getModels();
          setSnackBar(
            true,
            "success",
            `${injectIntlTranslation(
              intl,
              "newModelCreateSucess",
              constants.newModelCreateSucess
            )} ${newModel?.model}`
          );
          setLoading(false);
        }
      } catch (error) {
        setShowNewModel(false);
        setSnackBar(
          true,
          "error",
          `${injectIntlTranslation(
            intl,
            "createModelError",
            constants.createModelError
          )} ${newModel?.model}`
        );
      }
    }
  };

  const deleteConfirm = async (selectedModel) => {
    try {
      await deleteModel({ modelId: selectedModel.modelId });
      if (!modelState.deleteModel.hasError) {
        setShowDelete(false);
        await getModels();

        setSnackBar(
          true,
          "success",
          `${selectedModel.modelName} ${injectIntlTranslation(
            intl,
            "modelDeleteSuccess",
            constants.modelDeleteSuccess
          )}`
        );
      }
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `${injectIntlTranslation(
          intl,
          "modelDeleteError",
          constants.modelDeleteError
        )} ${selectedModel.modelName}`
      );
    }
  };

  const updatePropertyName = (inputArray, oldPropertyName, newPropertyName) => {
    const updatedArray = inputArray?.map((obj) => {
      const { [oldPropertyName]: propertyValue, ...rest } = obj;
      return {
        [newPropertyName]: propertyValue,
        ...rest,
      };
    });
    return updatedArray;
  };

  useEffect(() => {
    let oldArray = [...modelState?.regions?.data];
    const updatedArray = updatePropertyName(oldArray, "regionName", "label");
    setRegions(updatedArray);
  }, [modelState?.regions?.data]);

  const handleShowEdit = () => {
    setShowEdit(false);
    setShowMoreOptions(false);
    setShowMoreOptionsDisabled(false);
  };

  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={12} md={9} className="page-content">
        <Grid container item xs={12} md={5} className="page-menu"></Grid>
        <Grid
          container
          item
          xs={12}
          md={7}
          className="page-menu"
          justify="flex-end"
        >
          <Grid
            item
            container
            xs={12}
            md={5}
            justify="center"
            className="search-wrapper"
          >
            <TextField
              id="search"
              placeholder={injectIntlTranslation(
                intl,
                "searchPlacholder",
                constants.searchPlacholder
              )}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleSearch(e.target.value)}
              autoComplete={"off"}
            />
          </Grid>
          <Grid item container xs={12} md={3} justify="flex-end">
            {/* <DMSelect
              id="sort-by-select"
              label={injectIntlTranslation(intl, "sortByLabel" , constants.sortByLabel)}
              lists={MODELS_CONTROLS.SORT_FIELDS}
              onChange={handleChange}
            /> */}
          </Grid>
          <Grid item container xs={12} md={3} justify="flex-end">
            <CustomButton
              id="newModel"
              showGradient={true}
              variant="contained"
              color="primary"
              disabled={false}
              name={injectIntlTranslation(
                intl,
                "newModelBtnLabel",
                constants.newModelBtnLabel
              )}
              onClick={onNewProjectClick}
            />
          </Grid>
        </Grid>
        {gridData?.length > 0 && (
          <DMGrid
            headers={MODELS_CONTROLS.GRID_HEADERS}
            headerClassName={classes.gridHeaderColumns}
            data={gridData}
            selectedPage={modelState.selectedPage}
            onPageSelection={onSelectedPage}
            setGridData={(t) => {
              setGridData(t);
            }}
          />
        )}

        <WarningPopup
          open={showNewModel}
          onClose={() => {
            setIsDisabled(true);
            setShowNewModel(false);
          }}
          title={injectIntlTranslation(
            intl,
            "createNewModel",
            constants.createNewModel
          )}
          description={
            <form style={{ textAlign: "center" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} style={{ width: "100%" }}>
                  <TextField
                    id="outlined-basic"
                    label={injectIntlTranslation(
                      intl,
                      "modelNameLabel",
                      constants.modelNameLabel
                    )}
                    variant="outlined"
                    onChange={handleNewModelName}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} style={{ width: "100%" }}>
                  <FormControl
                    className={classes.formControl}
                    style={{ width: "100%", margin: "0" }}
                  >
                    <TextField
                      id=""
                      select
                      labelId="region-name-select-required-label"
                      label={injectIntlTranslation(
                        intl,
                        "modelRegionLabel",
                        constants.modelRegionLabel
                      )}
                      variant="outlined"
                      onChange={handleRegionNewModel}
                      placeholder={injectIntlTranslation(
                        intl,
                        "modelRegionLabel",
                        constants.modelRegionLabel
                      )}
                      style={{ width: "100%", margin: "0", textAlign: "left" }}
                    >
                      {updatePropertyName(
                        modelState?.regions?.data,
                        "regionName",
                        "label"
                      ).map((region) => {
                        return (
                          <MenuItem value={region.regionId}>
                            {region.label}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    width: "100%",
                    textAlign: "right",
                    paddingRight: "25px",
                  }}
                >
                  <Typography
                    component="div"
                    style={{ display: "inline-block" }}
                  >
                    <Grid
                      component="label"
                      container
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>
                        <Typography style={{ fontSize: "20px" }}>
                          {injectIntlTranslation(
                            intl,
                            "isActiveLabel",
                            constants.isActiveLabel
                          )}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <AntSwitch
                          checked={newModel?.status}
                          onChange={handleStatusNewModel}
                          name={"Status"}
                        />
                      </Grid>
                    </Grid>
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "right", marginTop: "10px" }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleCreateModel}
                    disabled={isDisabled}
                    className={classes.saveButton}
                  >
                    {injectIntlTranslation(
                      intl,
                      "createBtnLabel",
                      constants.createBtnLabel
                    )}
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowNewModel(false);
                    }}
                    className={classes.cancelbutton}
                  >
                    {injectIntlTranslation(
                      intl,
                      "cancelBtnLabel",
                      constants.cancelBtnLabel
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          }
          hideBtn={true}
        />

        <WarningPopup
          open={showDelete}
          onClose={() => setShowDelete(false)}
          title={injectIntlTranslation(
            intl,
            "modelDeleteTitle",
            constants.modelDeleteTitle
          )}
          description={injectIntlTranslation(
            intl,
            "modelDeleteWarning",
            constants.modelDeleteWarning
          )}
          saveButtonLabel={injectIntlTranslation(
            intl,
            "deleteBtnLabel",
            constants.deleteBtnLabel
          )}
          onSave={() => {
            deleteConfirm(selectedModel);
          }}
        />
        <WarningPopup
          open={unsaveChangePopup}
          onClose={() => setUnsaveChangePopup(false)}
          title={injectIntlTranslation(
            intl,
            "unsaveWarningTitle",
            constants.unsaveWarningTitle
          )}
          description={injectIntlTranslation(
            intl,
            "unsaveWarningContent",
            constants.unsaveWarningContent
          )}
          saveButtonLabel={injectIntlTranslation(
            intl,
            "yesBtnLable",
            constants.yesBtnLable
          )}
          onSave={() => {
            onCloseSelected({
              id: "",
              isClosed: true,
            });
            setUnsaveChangePopup(false);
            setIsUnsaveChanges(false);
          }}
        />

        <WarningPopup
          open={regionUpate}
          onClose={() => setRegionUpate(false)}
          title={injectIntlTranslation(
            intl,
            "modelRegionTitle",
            constants.modelRegionTitle
          )}
          description={`${injectIntlTranslation(
            intl,
            "modelRegionUpateMsg",
            constants.modelRegionUpateMsg
          )} ${regionUpate.modelName || ""} ?`}
          saveButtonLabel={injectIntlTranslation(intl, "Update", "Update")}
          onSave={() => {
            if (regionUpate?.callBack) {
              const { callBack = () => {} } = regionUpate;
              callBack();
            }
            setRegionUpate(false);
          }}
        />

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
            setShowMoreOptions(false);
            // setShowMoreOptionsDisabled(false);
          }}
        >
          <MenuItem
            onClick={() => handleMoreOptionsClose(1)}
            // disabled={showMoreOptionsdisabled}
          >
            {injectIntlTranslation(intl, "editDdNname", constants.editDdNname)}
          </MenuItem>
          <MenuItem
            onClick={() => handleMoreOptionsClose(2)}
            // disabled={showMoreOptionsdisabled}
          >
            {injectIntlTranslation(intl, "editviews", constants.editviews)}
          </MenuItem>
          <MenuItem
            onClick={() => handleMoreOptionsClose(3)}
            // disabled={showMoreOptionsdisabled}
          >
            {injectIntlTranslation(
              intl,
              "editDrawings",
              constants.editDrawings
            )}
          </MenuItem>
          <MenuItem
            onClick={() => handleMoreOptionsClose(6)}
            // disabled={showMoreOptionsdisabled}
          >
            {injectIntlTranslation(
              intl,
              "editConfigMsg",
              constants.editConfigMsg
            )}
          </MenuItem>
          {/* <Divider style={{ width: "90%", marginLeft: "7px" }} /> */}
          {/* <MenuItem
            onClick={() => {
              handleMoreOptionsClose(4);
            }}
            disabled={showMoreOptionsdisabled}
          >
           {injectIntlTranslation(intl, "editBlockInformation" , constants.editBlockInformation)}
          </MenuItem>
          <MenuItem onClick={() => handleMoreOptionsClose(5)}>
          {injectIntlTranslation(intl, "seeVersionHistory" , constants.seeVersionHistory)}
          </MenuItem> */}
        </Menu>
      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modelState: state.model,
  fullLangCode: state.locale.message,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getModels: async () => dispatch(modelAction.getModels()),
    deleteModel: async (requestPayload) =>
      dispatch(modelAction.deleteModel(requestPayload)),
    createNewModel: async (requestPayload) =>
      dispatch(modelAction.createNewModel(requestPayload)),
    updateModel: async (requestPayload) =>
      dispatch(modelAction.updateModel(requestPayload)),
    getRegions: async () => dispatch(modelAction.getRegions()),
    onMoreOptionsSelected: (modelId) =>
      dispatch(miscAction.onModelSelected(modelId)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onPageSelected: (selectedPage) =>
      dispatch(modelAction.setModelSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Models));
